class HeaderEl extends HTMLElement {
  connectedCallback() {
    this.button = this.querySelector('[data-burger]');
    this.searchButton = this.querySelector('[data-search-button]');
    this.closeSearchButton = this.querySelector('[data-close-search]');
    this.searchOverlay = this.querySelector('.header__search-overlay');
    this.searchInput = this.querySelector('.header__search-input');

    this.button.addEventListener('click', () => {
      this.classList.contains('active') ? this.close() : this.open();
    });

    this.searchButton.addEventListener('click', () => {
      this.toggleSearch();
    });

    this.closeSearchButton.addEventListener('click', () => {
      this.closeSearch();
    });

    this.addEventListener('click', (e) => {
      if (e.target.tagName === 'A' && window.matchMedia('(max-width: 1179px)').matches) {
        this.close();
      }
    });

    this.addEventListener('keydown', (e) => {
      if (e.key === 'Escape') {
        this.close();
        this.closeSearch();
      }
    });

    // Close search when clicking outside
    document.addEventListener('click', (e) => {
      if (this.searchOverlay.classList.contains('active') && 
          !this.searchOverlay.contains(e.target) && 
          e.target !== this.searchButton) {
        this.closeSearch();
      }
    });
  }

  toggleSearch = () => {
    if (this.searchOverlay.classList.contains('active')) {
      this.closeSearch();
    } else {
      this.openSearch();
    }
  }

  openSearch = () => {
    const windowHeight = window.innerHeight ;
    const currentScroll = window.scrollY;

    console.log('openSearch');

    if (document.body.classList.contains('home-page') && (currentScroll < windowHeight)) {
      window.scrollTo({
        top: windowHeight,
        behavior: 'smooth'
      });
      
      this.classList.add('search-active');
      this.searchOverlay.classList.add('active');
      
      if (this.classList.contains('active')) {
        this.close();
      }
      
      setTimeout(() => {
        this.searchInput.focus();
      }, 350);
    } else {
      this.classList.add('search-active');
      this.searchOverlay.classList.add('active');

      if (this.classList.contains('active')) {
        this.close();
      }
      
      setTimeout(() => {
        this.searchInput.focus();
      }, 350);
    }
  }

  closeSearch = () => {
    this.classList.remove('search-active');
    this.searchOverlay.classList.remove('active');
    this.searchInput.value = '';
  }

  open = () => {
    const windowHeight = window.innerHeight + 80;
    const currentScroll = window.scrollY;

    if (document.body.classList.contains('home-page') && (currentScroll < windowHeight)) {
      window.scrollTo({
        top: windowHeight,
        behavior: 'smooth'
      });

      console.log('open');

      // Wait for scroll to complete before opening menu
      setTimeout(() => {
        this.classList.add('active');
        setTimeout(() => {
          this.scrollPosition = window.scrollY;
          document.body.style.position = 'fixed';
          document.body.style.top = `-${this.scrollPosition}px`;
        }, 251);
      }, 500); // Adjust timing based on scroll animation
    } else {
      console.log('open else');
      this.classList.add('active');
      setTimeout(() => {
        this.scrollPosition = window.scrollY;
        document.body.style.position = 'fixed';
        document.body.style.top = `-${this.scrollPosition}px`;
      }, 251);
    }
  }

  close = () => {
    console.log('close');
    document.body.style.position = '';
    document.body.style.top = '';
    const scrollBehavior = document.documentElement.style.scrollBehavior;
    document.documentElement.style.scrollBehavior = 'auto';
    window.scrollTo(0, this.scrollPosition);
    document.documentElement.style.scrollBehavior = scrollBehavior;
    this.classList.remove('active');
  }
}

customElements.define('header-el', HeaderEl);